'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Switch = function (_PureComponent) {
	_inherits(Switch, _PureComponent);

	function Switch() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Switch);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Switch.__proto__ || Object.getPrototypeOf(Switch)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
			var _this$props = _this.props,
			    active = _this$props.active,
			    onChange = _this$props.onChange;

			onChange({
				active: !active
			});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Switch, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    active = _props.active,
			    disabled = _props.disabled,
			    label = _props.label,
			    labelOnLeft = _props.labelOnLeft,
			    theme = _props.theme;


			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)('bnc_field_switch', 'theme--' + theme, {
						'--label-on-left': labelOnLeft,
						'--active': active,
						'--disabled': disabled
					}) },
				_react2.default.createElement(
					'label',
					null,
					labelOnLeft && _react2.default.createElement(
						'span',
						null,
						label
					),
					_react2.default.createElement('input', {
						disabled: disabled,
						type: 'checkbox',
						onChange: this.onChange,
						checked: this.props.active
					}),
					!labelOnLeft && _react2.default.createElement(
						'span',
						null,
						label
					)
				)
			);
		}
	}]);

	return Switch;
}(_react.PureComponent);

Switch.propTypes = {
	active: _propTypes2.default.bool,
	onChange: _propTypes2.default.func.isRequired,
	disabled: _propTypes2.default.bool,
	label: _utils.StringOrReact,
	labelOnLeft: _propTypes2.default.bool,
	theme: _propTypes2.default.string
};

Switch.defaultProps = {
	active: true,
	disabled: false,
	label: '',
	labelOnLeft: false,
	theme: 'blue'
};

exports.default = Switch;